import avatar from "../../assets/imgs/game-details/avatar.png"
import { cleanHtml, shortenHex } from "../../utils/string"
import { timeFromNow } from "../../utils/date"
import { DislikeSvg, LikeSvg } from "../../assets/svg"
import React from "react"
import { useTranslation } from "next-i18next"

const CommentItem = (props) => {
    const { t: tCommon } = useTranslation("common")
    const { t: tGameDetails } = useTranslation("game-details")

    const parentComment = props.parentComment
    const comment = props.comment
    const isChild = comment.id !== parentComment.id
    const onLike = props.onLike
    const onDisLike = props.onDisLike
    const onReplyComment = props.onReplyComment
    const fetchChildComments = props.fetchChildComments

    const transformComment = (content) => {
        return content.replace(/\@\(\S+\)/gi, function replace(match) {
            return `<span class="text-accent-4 rounded-[4px]">${match.replace(/[()]/gi, "")}</span>`
        })
    }

    return (
        <div className="mb-5 flex text-14" key={comment.id}>
            <div className={`mr-3 ${isChild ? "h-[25px] w-[25px]" : "h-[40px] w-[40px]"}`}>
                <img
                    key={comment.customer.avatar ? comment.customer.avatar : avatar.src}
                    src={comment.customer.avatar ? comment.customer.avatar : avatar.src}
                    className={"rounded-[50%]"}
                />
            </div>
            <div className="flex-1">
                <p>
                    <span className="font-secondary font-bold text-accent-1">
                        {shortenHex(comment.customer.walletAddress)}
                    </span>
                    <span className="ml-2 font-secondary text-11 opacity-50">{timeFromNow(comment.createdAt)}</span>
                </p>
                <p className="mt-1 mb-2 leading-[17px]">
                    <span dangerouslySetInnerHTML={{ __html: cleanHtml(transformComment(comment.content)) }}></span>
                </p>
                <div className="flex">
                    <div className={"b-flex-center group relative"}>
                        <LikeSvg
                            width={16}
                            height={16}
                            className={`cursor-pointer hover:fill-black ${comment.customerLiked && "fill-black"}`}
                            onClick={() => onLike(comment)}
                        />
                        <div
                            className={`b-flex-center b-inset-center top-auto -bottom-[20px] hidden h-[19px] w-[32px] translate-y-0 rounded-[2px] bg-neutral-1-800 text-sm text-neutral-1-600 opacity-80 group-hover:flex`}
                        >
                            <div className="absolute -top-[2px] z-20 h-[6px] w-[6px] rotate-45 bg-neutral-1-800"></div>
                            {tGameDetails("details.like")}
                        </div>
                    </div>
                    <span className="ml-2 mr-5 font-secondary">{comment.likeCount}</span>
                    <div className={"b-flex-center group relative"}>
                        <DislikeSvg
                            width={16}
                            height={16}
                            className={`cursor-pointer hover:fill-black ${comment.customerDisliked && "fill-black"}`}
                            onClick={() => onDisLike(comment)}
                        />
                        <div
                            className={`b-flex-center b-inset-center top-auto -bottom-[20px] hidden h-[19px] w-[40px] translate-y-0 rounded-[2px] bg-neutral-1-800 text-14 opacity-80 group-hover:flex`}
                        >
                            <div className="absolute -top-[2px] z-20 h-[6px] w-[6px] rotate-45 bg-neutral-1-800"></div>
                            {tGameDetails("details.dislike")}
                        </div>
                    </div>
                    <span className="ml-2 mr-5 font-secondary ">{comment.dislikeCount}</span>
                    <button
                        className="font-secondary text-14 hover:text-accent-1"
                        onClick={() => onReplyComment(comment, parentComment)}
                    >
                        {tCommon("button.reply")}
                    </button>
                </div>
                {!isChild && (
                    <div className="mt-2">
                        <p
                            className="cursor-pointer bg-[url(../assets/imgs/icon/bottom.svg)] bg-[left_center] bg-no-repeat pl-4   font-bold text-primary-500 hover:text-accent-1"
                            onClick={() => fetchChildComments(comment)}
                        >
                            {tGameDetails("details.replies", { count: comment.replyCount })}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CommentItem
